export { default } from './PgeVideoPlayer';
